import { createSlice } from "@reduxjs/toolkit";

const cashflowAnalysisSlice = createSlice({
    name: "cashflowAnalysis",
    initialState: {
        cashflowAnalysisDetails: null,
        cashflowAnalysisError: null,
        cashflowAnalysisLoading: false,
    },
    reducers: {
        setCashflowAnalysisDetails: (state, { payload }) => {
            state.cashflowAnalysisDetails = payload;
        },
        setCashflowAnalysisError: (state, { payload }) => {
            state.cashflowAnalysisError = payload;
        },
        setCashflowAnalysisLoading: (state, { payload }) => {
            state.cashflowAnalysisLoading = payload;
        },
    }
});

export const { setCashflowAnalysisDetails, setCashflowAnalysisError, setCashflowAnalysisLoading } = cashflowAnalysisSlice.actions;

export default cashflowAnalysisSlice.reducer;